module.exports = __webpack_public_path__ + "img/remy-and-rose_thumbnail.0469321a.jpg";